export const getAttributs = (state) => state.attributs
export const getAttribut = (state) => (id) => state.attributs.find((attribut) => attribut.id == id)
